import { ArrowLeft } from "@phosphor-icons/react";
import { useState } from "react";
import type { StatusResponse } from "../../shared/types";
import { PortraitSharePanel } from "../components/PortraitSharePanel";
import { SiteFooter } from "../components/SiteFooter";

interface Props {
  token: string;
}

export function StatusPage({ token }: Props) {
  const [status, setStatus] = useState<StatusResponse | null>(null);
  const state = status?.state ?? "processing";
  const textOnly = status?.hasPhoto === false;
  const loading = status === null;

  return (
    <>
    <main className={`status-page status-page--${state}`}>
      <nav className="status-page__nav" aria-label="Story navigation">
        <a className="back-link" href="/"><ArrowLeft size={20} weight="bold" /> Back</a>
        <span className="eyebrow">Your story</span>
      </nav>
      <header className="status-page__header">
        <span className="eyebrow">{loading ? "Your story" : state === "ready" ? "Complete" : state === "withdrawn" ? "Your choice" : state === "rejected" ? "Not published" : textOnly ? "Message received" : "Processing"}</span>
        <h1>{loading ? <>Celebration<br />story</> : state === "ready" ? <>Ready for the<br />dance floor</> : state === "withdrawn" ? <>Removed<br />by you</> : state === "rejected" ? <>Sorry,<br />try again</> : textOnly ? <>On its<br />way</> : <>In the<br />making</>}</h1>
      </header>
      <PortraitSharePanel token={token} onStatus={setStatus} />
    </main>
    <SiteFooter />
    </>
  );
}
